<template>
    <div>
        <v-autocomplete
            v-model="batch"
            :items="batchOptions"
            :loading="loadingBatches"
            v-model:search="search"
            clearable
            hide-selected
            item-title="name"
            item-value="name"
            prepend-icon="$flask-outline"
            append-icon=""
            label="Batch Name"
            @update:model-value="onUpdate"
            placeholder="Start typing to Search Batches"
            return-object
        >
            <template v-slot:no-data="">
                <div v-if="!search || search.length < 4" class="ma-4">Keep typing...</div>
            </template>
        </v-autocomplete>
    </div>
</template>

<script>
import { defineComponent } from "vue";

import _ from "lodash";
import axios from "../../lib/apiAxios";
import { mapActions, mapGetters } from "vuex";

export default defineComponent({
    name: "BatchSearch",
    props: ["experiment"],

    data() {
        return {
            batch: null,
            batchOptions: [],
            search: "",
            loadingBatches: false,
            showProtocolSelectionDialog: false,
        };
    },

    computed: {
        ...mapGetters("plateCreate", ["protocols"]),
        type: function () {
            return this.$route.query.type;
        },
    },

    methods: {
        ...mapActions("plateCreate", ["setActiveCondition"]),
        async doSearchBatch(value, self) {
            // Handle empty value
            if (!value) {
                self.batchOptions = [];
                self.batch = "";
            }
            // Items have already been requested
            if (self.loadingBatches) {
                return;
            }

            self.loadingBatches = true;

            try {
                const res = await axios.get(`/benchling/allbatches/${self.search}`);
                self.batchOptions = res.data;
                self.loadingBatches = false;
            } catch (err) {
                console.error(err);
            }
        },
        onUpdate() {
            const active = this.batch;
            if (active) {
                active.experiment_code = this.experiment.exp;
                active.experiment_id = this.experiment.id;
                this.setActiveCondition(active);
            }
        },
    },

    watch: {
        search(val) {
            if (!val) {
                this.batchOptions = [];
            }
            if (!val || val.length < 4) {
                return;
            }
            return _.debounce(this.doSearchBatch, 200)(val, this);
        },
    },
});
</script>
<style scoped></style>
